<template>
    <div :style="{padding : isMobile ? '10px' : '20px'} ">
        <v-layout row wrap>
            <v-flex v-if="!isMobile" :xs3="!isIE" :class="{'mobileCompensation' : isMobile}" style="min-width: 268px;">
                <v-layout row wrap>
                    <v-flex xs12 sm12>
                        <v-card class="card elevation-4">
                            <loader :loading="loading" :height="pnecHeight">
                                <pnec :pnec="pnec" :height="pnecHeight"></pnec>
                            </loader>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex :xs3="!isIE && !isMobile" :class="{'mobileCompensation' : isMobile}">
                <v-layout row wrap>
                    <v-flex xs12 sm12>
                        <v-card v-if="mec.hasData()" class="card elevation-4">
                            <loader :loading="loading" :height="chartHeight">
                                <rq :rq="rq" :height="chartHeight" @loading="loadingRQ=true"
                                    @loaded="loadingRQ = false">
                                </rq>
                            </loader>
                        </v-card>
                        <v-alert v-else outlined color="blue" text class="card elevation-4" style="font-size: 13px;" icon="i" :height="isMobile ? 'auto' : chartHeight">
                            No MEC data for selected filters
                        </v-alert>
                    </v-flex>
                    <v-flex xs12 sm12>
                        <v-card class="card elevation-4">
                            <loader :loading="loading" :height="shortHeight">
                                <stats :stats="stats"></stats>
                            </loader>
                        </v-card>
                    </v-flex>
                    <v-flex xs12 sm12>
                        <v-card v-if="mec.hasData()" class="card elevation-4">
                            <loader :loading="loading" :height="chartHeight">
                                <mec :mec="mec" :height="chartHeight" @loading="loadingMEC=true"
                                    @loaded="loadingMEC = false"></mec>
                            </loader>
                        </v-card>
                        <v-alert v-else outlined color="blue" text class="card elevation-4" style="font-size: 13px;" icon="i" :height="isMobile ? 'auto' : chartHeight">
                            No MEC data for selected filters
                        </v-alert>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex v-if="!isIE" :xs12="isMobile" :grow="!isMobile" :class="{'mobileCompensation' : isMobile}"
                :style="[{'padding-top' : isMobile ? '5px' : '0px'}]">
                <v-layout row wrap>
                    <v-flex xs12 sm12>
                        <v-card class="card elevation-4">
                            <loader :loading="loading" :height="mapHeight">
                                <geomap v-if="geo" :geo="geo" :height="mapHeight" :reset="reset" @loading="loadingGeomap=true"
                                    @loaded="loadingGeomap = false">
                                </geomap>
                            </loader>
                        </v-card>
                    </v-flex>
                    <v-flex v-if="isMobile" xs12 sm12>
                        <v-card class="card elevation-4">
                            <loader :loading="loading" :height="pnecHeight">
                                <pnec :pnec="pnec" :height="pnecHeight" :itemsPerPage="isMobile ? 999 : 999"></pnec>
                            </loader>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
        <div v-if="isIE" style="margin-top: 30px; font-size: 12px;">
            * Some functionality is not supported in your current browser Internet Explorer. To get the best experience,
            we recommend the latest version of Chrome, Edge, Safari or Firefox.
        </div>
    </div>
</template>

<script>
    import loader from './base/loader.vue'
    import stats from './stats.vue'
    import pnec from './pnec.vue'
    import { PNEC } from '../../ts/pnec.ts'

    export default {
        components: {
            loader,
            stats,
            pnec,
            mec: () => import('./mec.vue'),
            rq: () => import('./rq.vue'),
            geomap: () => import('./geomap.vue'), // TODO: dont need this import if using IE.
        },

        props: {
            rq: {
                required: true,
                //type: TODO: add I_RQ here. 
            },
            mec: {
                required: true,
                //type: TODO: add I_MEC here. 
            },
            geo: {
                required: true,
                //type: TODO: add I_Geo here. 
            },
            stats: {
                required: true,
                //type: TODO: add I_stats here. 
            },
            pnec: {
                required: true,
                type: PNEC
            },
            isMobile: {
                type: Boolean,
                default: false,
            },
            reset: {
                type: Boolean,
                default: false,
            }
        },

        data() {
            return {
                loadingRQ: true,
                loadingMEC: true,
                loadingGeomap: true,

                height: 268,

                isIE: (navigator.userAgent.indexOf("MSIE ") > -1) || (navigator.userAgent.indexOf("Trident/") > -1),
            }
        },
        computed: {
            loading() {
                const showRQ = () => {
                    if (this.rq.barChartData && this.rq.barChartData.length > 0) {
                        return this.loadingRQ
                    } else {
                        return false
                    }
                }
                const showMEC = () => {
                    if (this.mec.lineChartData && this.mec.lineChartData.length > 0) {
                        return this.loadingMEC
                    } else {
                        return false
                    }
                }
                const showGeo = () => {
                    if (this.geo.data && this.geo.data.length > 0) {
                        return this.loadingGeomap
                    } else {
                        return false
                    }
                }

                if (this.isIE) { // map not present in IE.
                    return showRQ() || showMEC()
                } else {
                    return showRQ() || showMEC() || showGeo()
                }
            },
            pnecHeight() {
                return this.isMobile ? null : (this.height * 2.5) + 40
            },
            mapHeight() {
                return this.isMobile ? this.height * 1.5 : (this.height * 2.5) + 40
            },
            chartHeight() {
                return this.isMobile ? this.height : this.height * 0.91
            },
            shortHeight() {
                return this.height * 0.68
            }
        },
    }

</script>

<style scoped>
    .card {
        margin: 10px 20px;
    }

    .mobileCompensation {
        padding: 20px 5px 10px;
    }
</style>